/**
 * Constantes du jeu Griffonne (spec games/griffonne §2/§5/§6). Bornes validées
 * côté serveur ; le salon commun ignore la config (valeurs par défaut figées).
 */
export const GRIFFONNE_SLUG = 'griffonne';
export const GRIFFONNE_NAMESPACE = '/griffonne';

/** Joueurs : min pour démarrer, max par partie (exigence : ≤ 8). */
export const GRIFFONNE_MIN_PLAYERS = 2;
export const GRIFFONNE_MAX_PLAYERS = 8;

/** Manches par partie (exigence : jusqu'à 10, configurable en privé). */
export const GRIFFONNE_DEFAULT_ROUNDS = 10;
export const GRIFFONNE_MIN_ROUNDS = 2;
export const GRIFFONNE_MAX_ROUNDS = 20;

/** Durée de dessin d'une manche en secondes (exigence : 30 s max par défaut). */
export const GRIFFONNE_DEFAULT_DRAW_SEC = 30;
export const GRIFFONNE_MIN_DRAW_SEC = 15;
export const GRIFFONNE_MAX_DRAW_SEC = 120;

/** Le dessinateur choisit 1 mot parmi 3 dans ce délai (sinon auto-pick). */
export const GRIFFONNE_WORD_CHOICES = 3;
export const GRIFFONNE_DEFAULT_PICK_SEC = 15;
export const GRIFFONNE_MIN_PICK_SEC = 5;
export const GRIFFONNE_MAX_PICK_SEC = 30;

/** Pause entre deux manches (révélation du mot + scores). */
export const GRIFFONNE_ROUND_END_SEC = 5;

/**
 * Grâce avant de kicker un joueur DÉCONNECTÉ d'un salon COMMUN en partie active
 * (spec §10). Au-delà, exclusion « déconnexion ». Les parties privées ne kickent
 * pas sur déconnexion (le joueur garde sa place).
 */
export const GRIFFONNE_DISCONNECT_KICK_SEC = 60;

/**
 * Durée pendant laquelle une partie EN ATTENTE reste « existante » (joignable par
 * code) une fois vidée de tout le monde (spec §5.2). Au-delà, elle est abandonnée
 * (DB `aborted`) et l'état mémoire libéré. Tant que ≥ 1 joueur est connecté, elle
 * ne s'éteint jamais.
 */
export const GRIFFONNE_WAITING_GRACE_SEC = 300;

/** Barème (spec §6) — indicatif, ajustable en metadata. */
export const GRIFFONNE_SCORE_BASE = 300; // points max d'un devineur (à vitesse maximale)
export const GRIFFONNE_SCORE_MIN_SOLVE = 50; // plancher pour un devineur qui trouve
export const GRIFFONNE_SCORE_ORDER_BONUS = [50, 30, 10] as const; // 1er, 2e, 3e à trouver
export const GRIFFONNE_SCORE_DRAWER_BASE = 250; // points max du dessinateur

/** Difficultés (équilibrage du tirage + packs privés). */
export const GRIFFONNE_DIFFICULTIES = ['easy', 'medium', 'hard'] as const;
export type GriffonneDifficulty = (typeof GRIFFONNE_DIFFICULTIES)[number];
